import React from 'react'
import playStore from '../media/images/play_store.png'
import appStore from '../media/images/app_store.png'
import { Link } from 'react-router-dom'


const AppDownloadsComponent = () => {
  return (
    <div>

      <div className="app-download-component">
        <div className="app-download-component-main">
          <Link target='_blank' to="https://play.google.com/store/apps/details?id=com.fluffytouchapp"><img src={playStore} alt="PlayStore logo" title='At Home Pet Grooming App' /></Link>
          <Link target='_blank' to="https://play.google.com/store/apps/details?id=com.fluffytouchapp"><img src={appStore} alt="AppStore logo" title='At Home Pet Grooming App' /></Link>
        </div>
      </div>
      
    </div>
  )
}

export default AppDownloadsComponent